import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ManageTestBooklets from 'assets/svgs/manageTestBooklets.svg';
import { Link } from 'react-router-dom';

import {
  filter,
  sumBy,
} from 'lodash';

import './TcEventMaterials.scss';

const TcEventMaterials = ({ event, tcEventMaterialTypes, eventMaterials, roomMaterialsCount, showMaterials }) => {
  const { t } = useTranslation();
  return (
    <section className="event-materials-section">
      {showMaterials &&
        <div className='tc-event-materials'>
          {tcEventMaterialTypes.map(materialType => {
            let materials =
              filter(roomMaterialsCount, room => room.materials.some(material => material.materialTypeId === materialType.id && material.total));

            return (
              !!materialType &&
              <div key={materialType.id}>
                <span>{materialType.name}: </span>
                {!!eventMaterials[materialType.id] && sumBy(eventMaterials[materialType.id],'count') || 0} ({t('testCenter.testMaterials.bookletsAssignedCount', {count: materials.length, total: roomMaterialsCount.length})})
              </div>
            )}
          )}
        </div>
      }

      <Link
        to={`/test-event/${event.id}/test-materials`}
        href={`/test-event/${event.id}/test-materials`}
        className="mt-2 btn-link svg-right"
      >
        <ManageTestBooklets/>{t('testCenter.testMaterials.manageMaterials')}
      </Link>
    </section>
  );
};

export default TcEventMaterials;

TcEventMaterials.propTypes = {
  event: PropTypes.shape({}).isRequired,
};
